var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "media tweet-external-link" }, [
    _vm.exturl.type === "Link"
      ? _c("img", {
          staticClass: "extlink-prefix-img mr-2",
          attrs: {
            src: "/static/images/link.svg",
            alt: "External document link"
          }
        })
      : _vm.exturl.type === "Image"
      ? _c("img", {
          staticClass: "extlink-prefix-img  mr-2",
          attrs: {
            src: "/static/images/picture.svg",
            alt: "External image link"
          }
        })
      : _c("img", {
          staticClass: "extlink-prefix-img  mr-2",
          attrs: {
            src: "/static/images/play-button.svg",
            alt: "External video link"
          }
        }),
    _vm._v(" "),
    _c("div", { staticClass: "media-body" }, [
      _c("div", [
        _c("a", { attrs: { href: _vm.exturl.url } }, [
          _vm._v(_vm._s(_vm.exturl.url))
        ]),
        _vm._v(" "),
        _vm.exturl.type === "Link"
          ? _c(
              "div",
              _vm._l(_vm.exturl.checks, function(check) {
                return _c("div", { key: check.text }, [
                  _c("span", { class: ["badge", check.badge_class] }, [
                    _vm._v(_vm._s(check.text))
                  ])
                ])
              }),
              0
            )
          : _vm._e()
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }